import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PortalAndLineupApplicationConnectionService } from 'src/shared-app-portal/services/portal-and-lineup-application-connection.service';

@Component({
  selector: 'app-login',
  template: ``,
  standalone: false
})
export class PortalLoginComponent implements OnInit {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private portalAndLineupApplicationConnectionService: PortalAndLineupApplicationConnectionService
  ) {}
  ngOnInit() {
    const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      if (isAuthenticated) {
        if (returnUrl) {
          this.router.navigate([returnUrl]);
          return;
        }
        if (this.portalAndLineupApplicationConnectionService.hasFormReturnUrl()) {
          this.portalAndLineupApplicationConnectionService.backToFormReturnUrl();
          return;
        }
        if (this.portalAndLineupApplicationConnectionService.hasReturnUrl()) {
          this.portalAndLineupApplicationConnectionService.backToPortal();
          return;
        }
        this.router.navigate(['/portal/dashboard']);
      } else {
        this.oidcSecurityService.authorize();
      }
    });
  }
}
